export const QA_NAME_LISTING_FORM_NO_UNITS_LINK = 'listingFormNoUnitsFlatsLink'
